import { DEFAULT_ACCESS_ROLE } from "const/auth/const";
import { AccessRoleType } from "types/auth/role/RoleType";
import { Util } from "Util";
import { create } from "zustand";

interface AccessStoreType {
  accessRole: AccessRoleType;
  setAccessRole: (newAccessRole: AccessRoleType) => void;
}

const useAccessStore = create<AccessStoreType>((set, get) => ({
  accessRole: DEFAULT_ACCESS_ROLE,

  setAccessRole: (newAccessRole: AccessRoleType) => {
    if (!Util.isEqual(newAccessRole, get().accessRole)) {
      set({ accessRole: newAccessRole });
    }
  },
}));

export default useAccessStore;
